<template>
  <div class="idtr-block idtr-header">
    <img class="idtr-logo" :src="idtrAssets.logo" alt="" />
    <div class="idtr-report-box">
      <field-label target="idtr-report-number" class="idtr-report-box__label">
        {{ text.reportNumberLabel }}
      </field-label>
      <div>
        <field-input
          id="idtr-report-number"
          v-model="idtrForm.reportNumber"
          name="FTC Report Number"
          rules="required"
          digits
          :maxlength="9"
        />
      </div>
    </div>
    <div class="idtr-rule"></div>
  </div>
</template>

<script>
import FieldInput from "../FieldInput.vue";
import FieldLabel from "../FieldLabel.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldInput, FieldLabel},
  inject: ["idtrForm", "idtrAssets"],
  data: () => ({text: IDTR_TEXT}),
};
</script>
